import { getValueFromMeta } from '@/utils/utils';

export const spaceName = 'odOrderBill';

export interface BillSettings {
  data: any[];
  inputSearchBar: any;

  selectedIds: any[];
  paymentMethod?: any;
  editingOrder?: any;

  operatorInfo: {
    operatorName: string;
    printAfterPay: boolean;
  };

  showDetailDrawer: boolean;
  summaryInfo: {
    orderTotal?: number;
    discount?: number | string;
    tips?: number | string;
    notes?: string;
    tender?: number | string;
    extra?: number | string;
  };
}

export default {
  data: [],
  selectedIds: [],
  operatorInfo: {
    operatorName: '',
    printAfterPay: false,
  },
  showDetailDrawer: false,
  summaryInfo: {},
  inputSearchBar: {
    showall: '1',
  },
} as BillSettings;

export const getTableColumns = (props: any) => {
  const {
    helper: { tx },
    od: { editingBusiness },
    subtotalButton,
    actionButton,
    shippingMethod,
  } = props;

  const enableTradingMode = getValueFromMeta(editingBusiness.meta, 'enable_trading_mode');

  return [
    {
      title: enableTradingMode
        ? tx('Orders_Payments.order_number')
        : tx('Orders_Payments.table_or_ref_number'),
      dataIndex: 'referenceNumber',
      key: 'tableNumber',
      width: '130px',
    },
    {
      ...shippingMethod,
    },
    {
      title: tx('Orders_Payments.order_time'),
      dataIndex: 'orderTime',
      key: 'orderTime',
      width: '200px',
    },
    {
      title: tx('Orders_Payments.customer'),
      dataIndex: 'customer',
      key: 'customer',
      width: '125px',
    },
    {
      ...subtotalButton,
    },
    {
      ...actionButton,
    },
  ];
};

export const getChildrenTableColumns = () => {
  return [];
};
